import * as React from 'react';

import { Formatters } from '../../codegen/Localize';
import { boldClass } from '../styles/DefinitionSubspaceSharedStyles';
import { ConceptName } from '../types/ConceptName';
import { ValueConcept, ValueConceptValue } from '../types/ValueConcept';

export const highlightSearch = (targetText: string, searchText: string): React.ReactNode => {
  if (searchText === '') { return targetText; }
  return targetText
    .split(RegExp('(' + searchText + ')', 'gi'))
    .map((fragment: string, index: number) => (
      <React.Fragment key={index}>
        {
          (fragment.toLowerCase() === searchText.toLowerCase()) ?
          <span className={boldClass}>{fragment}</span>: fragment
        }
      </React.Fragment>));
};

export const formatValue = (value: ValueConceptValue) => (
  value.string_value !== undefined ? value.string_value :
  value.time_value !== undefined ? Formatters.formatMediumDateTimeWithoutSeconds(new Date(value.time_value)) :
  value.number_value !== undefined && value.number_value % 1 === 0 ? Formatters.formatCount(value.number_value) :
  value.number_value !== undefined ? Formatters.formatFloat(value.number_value) :
  value.bool_value !== undefined ? value.bool_value ? 'True' : 'False' :
  'Null'
);

export const compareValues = (a: ValueConceptValue, b: ValueConceptValue) => (
  a.string_value !== undefined ? a.string_value.localeCompare(b.string_value) :
  a.time_value !== undefined ? a.time_value - b.time_value :
  a.number_value !== undefined ? a.number_value - b.number_value:
  a.bool_value !== undefined ? a && 1 : 0
);

export const compareValueConcepts = (a: ValueConcept, b: ValueConcept) => compareValues(a.value, b.value);

export const dataRoleSingleValueMatchesSearch = (value: ValueConceptValue, searchText: string): boolean  =>
  formatValue(value)
    .toLocaleLowerCase()
    .indexOf(searchText.toLocaleLowerCase()) > -1;

export const valueConceptMatchesSearch = (valueConcept: ValueConcept, searchText: string): boolean  =>
  formatValue(valueConcept.value)
    .toLocaleLowerCase()
    .indexOf(searchText.toLocaleLowerCase()) > -1 ||
  valueConcept.names.some(name => conceptNameMatchesSearch(name, searchText));

export const conceptNameMatchesSearch = (name: ConceptName, searchText: string) =>
  name.name.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) > -1;
